import { api, qs } from "./base";
import type { ExceptionRow, FeedbackRow, ListResponse } from "@/common/types";

/** Exceptions by repo, state, or REQ#. */
export function listExceptions(params: {
  repo?: string;
  state?: string;
  req?: string;
}): Promise<ListResponse<ExceptionRow>> {
  return api.get<ListResponse<ExceptionRow>>(`/exceptions${qs(params)}`);
}

export function getException(exceptionId: string): Promise<ExceptionRow> {
  return api.get<ExceptionRow>(`/exceptions/detail${qs({ exceptionId })}`);
}

// -- write actions (actor recorded for audit until OKTA scopes carry the subject) --

export function approveException(exceptionId: string, actor: string) {
  return api.post(`/exceptions/approve${qs({ exceptionId })}`, { actor });
}

export function rejectException(
  exceptionId: string,
  actor: string,
  reason: string,
) {
  return api.post(`/exceptions/reject${qs({ exceptionId })}`, {
    actor,
    reason,
  });
}

export function withdrawException(exceptionId: string, actor: string) {
  return api.post(`/exceptions/withdraw${qs({ exceptionId })}`, { actor });
}

/**
 * Attach a pre-existing, externally-filed ServiceNow REQ to a finding's CVE(s), so
 * vuln-sentinel suppresses it. filedDate ('YYYY-MM-DD') anchors the 90-day re-eval window.
 */
export function attachException(
  actor: string,
  body: {
    repo: string;
    cveIds: string[];
    reqNumber: string;
    filedDate: string;
    findingArns?: string[];
    component?: string;
    groupKey?: string;
  },
) {
  return api.post<{
    ok: boolean;
    reqNumber: string;
    count: number;
    expiresAt: number;
  }>("/exceptions/attach", { actor, ...body });
}

// -- feedback (M4 Phase 2 — learning-loop input) --

/** All feedback for one exception PR (keyed by its prUrl as subjectId). */
export function listExceptionFeedback(
  subjectId: string,
): Promise<ListResponse<FeedbackRow>> {
  return api.get<ListResponse<FeedbackRow>>(`/feedback${qs({ subjectId })}`);
}

/** Submit engineer feedback on an exception. outcome ∈ APPROVED|REJECTED. subjectId = exception prUrl. */
export function submitExceptionFeedback(
  subjectId: string,
  repo: string,
  actor: string,
  outcome: string,
  comment: string,
) {
  return api.post(`/exceptions/feedback${qs({ exceptionId: subjectId })}`, {
    repo,
    outcome,
    comment,
    actor,
  });
}
